/* 🤖 this file was generated by svg-to-ts */
export const matIconSignalWifi4Bar: {
  name: 'signal-wifi-4-bar';
  data: string;
} = {
  name: 'signal-wifi-4-bar',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M12.01 21.49 23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7l11.63 14.49.01.01.01-.01z"/></svg>`
};
